import React from 'react'

/**
 * Holds a ref to a DOM element and polyfills React 19 ref callbacks with cleanup functions.
 */
const useTrackRef = <T extends HTMLElement>(
  onUpdate: (value: T) => (() => void) | void,
  enabled = true
): React.RefCallback<T | null> => {
  const cleanupRef = React.useRef<() => void>(null)

  const onUpdateRef = React.useRef(onUpdate)
  onUpdateRef.current = onUpdate

  return React.useCallback(
    (element: T | null) => {
      if (cleanupRef.current) {
        cleanupRef.current()
        cleanupRef.current = null
      }

      if (enabled && element) {
        cleanupRef.current = onUpdateRef.current(element) ?? null
      }
    },
    [enabled]
  )
}

export default useTrackRef
